<template>
  <div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" style="margin-top: 10px;">
      <van-cell v-for="(item, index) in sessionList" :key="index">
        <div class="session-item">
          <span>{{item.userName}}</span>
          <van-button style="margin-right: 10px;" type="info" @click="unassign(item)">取消分配</van-button>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      finished: false,
      sessionList: [],
      getConversationId: null
    }
  },
  created () {
    this.getConversationId = this.$route.query.conversationId
    this.getSessionList()
  },
  methods: {
    getSessionList () {

      this.$http.get("/scrm/v1/wxcp-chat-tool/o/getQwClientFollower", {
        params: {
          corpId: this.$store.state.auth.corpId,
          accountId: this.$store.state.auth.qwAccountId,
          conversationId: this.getConversationId
        },
      }).then((res) => {
        const { code, data, msg } = res
        this.loading = false
        this.finished = true;
        if (code === 1) {
          this.sessionList = data
        } else {
          this.$toast(`${msg}`)
        }
      })
    },

    unassign (item) {
      let followerIds = []
      followerIds.push(item.followerId)
      this.$http.post(`/scrm/v1/wxcp-chat-tool/o/delFollowUser?corpId=${this.$store.state.auth.corpId}`, { followerIds })
        .then((res) => {
          const { code, data, msg } = res
          if (code === 1) {
            this.$toast('取消分配成功')
            this.getSessionList()
          } else {
            this.$toast(`${msg}`)
          }
        })
    }
  }
}
</script>
<style lang="less" scoped>
.session-item {
  display: flex;
  justify-content: space-between;
  span {
    font-size: 16px;
    margin-left: 10px;
  }
  .van-button {
    height: 32px;
    border-radius: 6px;
  }
}
</style>
